
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/individuals-families",
      function () {
        return require("private-next-pages/individuals-families/index.page.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/individuals-families"])
      });
    }
  